import axiosInstance from "../../interceptor/intercetptor-inctence"



export const getTaxesAPI = (data) => {
	return axiosInstance.post(`pharma/get-taxes`, data)
}

export const createTaxAPI = (data) => {
	return axiosInstance.post(`pharma/create-tax`, data)
}

export const updateTaxAPI = (data) => {
	return axiosInstance.patch(`pharma/update-tax`, data)
}

export const deleteTaxAPI = (data) => {
	return axiosInstance.delete(`pharma/delete-tax`, { data });
}

export const getGstDiary = (data) => {
	return axiosInstance.post(`pharma/getGSTDiary`, data)
}
